<template>
    <div class="product-contents">
        <div class="unit-header">
            <div class="flex flex-align">
                <input type="text" class="search medium" placeholder="Search Contents" v-model="search" />
            </div>
            <h1>Table of Contents</h1>
        </div>
        <toc :children="productChildren" :search="search" />
    </div>
</template>

<script>
    export default {
        name: 'ProductContents',
        props: {
            contents: Array
        },
        data(){
            return {
                loading: true,
                search: ''
            };
        },
        computed: {
            productChildren(){
                console.log('product',this.$store.getters.product)
                const product = this.$store.getters.product;
                let localChildren = product.contents || [];
                    if( 
                        product?.metadata?.package_content_sort !== undefined
                        && Array.isArray(product.metadata.package_content_sort) 
                    ) {  //check sort is existing
                        var sortedList = [];
                        
                        product.metadata.package_content_sort.forEach( (val) => {
                            if(localChildren.filter( f => f.id === val )[0]) { // reordering snapshot

                                sortedList.push(localChildren.filter( f => f.id === val )[0]);
                                localChildren = localChildren.filter( f => f.id !== val );
                            }
                        })

                        localChildren = sortedList.concat(localChildren);
                    }
                return localChildren;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .unit-header
    {
        max-width: 800px;

        h1
        {
            margin-top: 30px;
        }
    }

    .product-contents
    {
        max-width: 800px;
    }
</style>